export const INCIDENCES_LIST_KEY = 'INCIDENCES_LIST';
export const INCIDENCES_ONE_KEY = 'INCIDENCES_ONE_KEY';

export const INCIDENCE_COMMENTS_LIST = 'INCIDENCE_COMMENTS_LIST';

export const INCIDENCE_ACTIONS_LIST = 'INCIDENCE_ACTIONS_LIST';

export const SOLUTION_ONE_KEY = 'SOLUTION_ONE_KEY';
